// helpers/Coveo/NoResultsMessage.tsx

import React from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useCoveoEngine } from 'lib/utils/coveo/SearchContext/CoveoEngineContext';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { Settings } from '.generated/Feature.CW.model';

type PageSettings = Settings.SiteSettings['fields'];

type NoResultsMessageProps = {
  className?: string;
};

const NoResultsMessage = ({ className }: NoResultsMessageProps): JSX.Element | null => {
  const { sitecoreContext } = useSitecoreContext();
  const contextWithSettings = sitecoreContext?.siteSettings as PageSettings;

  const engine = useCoveoEngine();
  const query = engine?.state?.query?.q || '';

  const rawHtml = contextWithSettings?.noSearchResultText?.value || '';

  if (!rawHtml) return null;

  const htmlWithReplacedTerm = rawHtml.replace(/{searchterm}/gi, query);

  return (
    <div className={className}>
      <RichTextWrapper
        field={{ value: htmlWithReplacedTerm }}
        className="
            py-16
            font-nunitoSans
            text-gray-900
            text-20
            leading-25

            [&_.heading]:border-b 
            [&_.heading]:border-gray-100 
            [&_.heading]:pb-12

            [&>ul]:pl-6 
            [&>li]:mb-2
        "
      />
    </div>
  );
};

export default NoResultsMessage;
